import { createContext } from 'react';

import { IAuthContext, IAuthData } from './types';
import { getTokensFromStorage } from './utils';

export const initialState: IAuthData = {
  me: null,
  tokens: getTokensFromStorage(),
  error: null,
  isActiveOperator: null,
  isOwner: null,
  isAuthInitialized:
    !getTokensFromStorage() && window.location.pathname === '/login',
  permissions: null,
};

const initialDataLoader = {
  load: () => null,
  loading: false,
};

export const AuthContext = createContext<IAuthContext>({
  data: initialState,
  actions: {
    setTokens: (tokens) => tokens,
    logout: () => null,
    setMe: () => null,
    loadMe: initialDataLoader,
    setError: () => null,
    clearError: () => null,
    setPermissions: () => null,
  },
});
